exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.breakText[data-v-51dad4cc]{word-break:break-all\n}\n[data-v-51dad4cc] .text .text{color:#ff0000 !important\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia.vue"],"names":[],"mappings":";AA6DA,4BACE,oBAAqB;CACtB;AAAA,8BAEG,wBAAyB;CAC1B","file":"InformacoesImovelTransferencia.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.breakText {\n  word-break: break-all;\n}\n>>> .text .text{\n    color: #ff0000 !important;\n  }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-51dad4cc","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/informacoesCadastro/cadastrosOnline/transferenciaDireitos/InformacoesImovelTransferencia.vue
// module id = b3gV
// module chunks = 12